// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"nL-z","carouselContainer":"oL-z"};